import React, { useCallback } from "react";

export const Guard = ({ auctionGuard }) => {
  console.log(auctionGuard);
  const onContinueCheckout = useCallback(() => {
    async function executor() {
      if (!auctionGuard) return;
      window.open(auctionGuard.invoice_url, "_self");
    }

    executor();
  }, [auctionGuard]);

  return (
    <div>
      <h1 className="text-4xl 5xl:text-5xl font-medium">
        Resume your purchase
      </h1>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            padding: "1.5rem",
          }}
        >
          <span className="text-base opacity-50">
            By placing your bid, you’re committing to buy this item if you win
            the auction. You will be charged 3% of the total auction cost to
            place your bid. If you do not win, this cost will be refunded to
            you.
          </span>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <button theme={"solid-dark"} type="submit" onClick={onContinueCheckout}>
          Continue
        </button>
        <button theme={"solid-light"} type="submit">
          Back
        </button>
      </div>
    </div>
  );
};
